import React, { useState, useRef } from 'react';
import { UseMap } from 'react-map-gl';


import {
    Alert,
    Badge,
    Card,
    Input,
    Checkbox,
    Button,
    Typography,
    IconButton,
    Radio,
    Tab,
    Tabs,
    TabsBody,
    TabsHeader,
    TabPanel,
    Select,
    Option,
    Textarea,
    Tooltip

} from "@material-tailwind/react";

import {
    PresentationChartBarIcon,
    ShoppingBagIcon,
    ArrowTopRightOnSquareIcon,
    MapIcon,
    ClipboardDocumentListIcon,
    UserCircleIcon,
    UsersIcon,
    Cog6ToothIcon,
    InboxIcon,
    InboxArrowDownIcon,
    PowerIcon,
    PencilIcon,
    TrashIcon,
    SparklesIcon,
    RectangleGroupIcon,
    FolderPlusIcon,
    //DocumentIcon,
    DocumentChartBarIcon,
    PaperClipIcon,
    FunnelIcon,
    

} from "@heroicons/react/24/outline";

import { FolderMinusIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import ShapeUnziper from './ShapeUnziper.jsx';

import * as turf from '@turf/turf'

import MapboxPanel from './MapBoxPanel.jsx';
import { json } from 'react-router-dom';
import Datepicker from "react-tailwindcss-datepicker";
import ConfirmDialog, { QueryDataDialog } from './ConfirmDialog.jsx';
import { showAlert } from './Alert.jsx';
import { geoportalGetParcelPolygon } from './geoportal.js';
import FileUploadCard from './FileUploadCard.jsx';
import { getAnalizy, getFieldFiles } from './AdminTools.jsx';
import DocumentIcon from './DocumentIcon.jsx';
import { getUserFiles } from './AdminTools.jsx';

export default function DoubleFieldCard(props) {

    const [fields, setFields] = useState(JSON.parse(localStorage.getItem("fields")) || []);
    const [files, setFiles] = useState(JSON.parse(localStorage.getItem("files")) || []);
    const [results, setResults] = useState([]);
    
    const [ownerid, setOwnerId] = useState();
    const [clientName, setClientName] = useState('');
    const [shape, setShape] = useState();
    const [action, setAction] = useState('create');
    const [fieldid, setFieldId] = useState(0);
    const [rank] = useState(localStorage.getItem("rank") || 0);

    const [panelSwitchTooltip, setPanelSwitchTooltip] = useState("Przełącz na widok 1 panelu")
    const [panelSwitchState, setPanelSwitchState] = useState(2);
    const [mapStyle, setMapStyle] = useState({ position: 'relative', width: '46vw', height: '86vh' });

    const [clearOnExit, setClearOnExit] = useState(false);
    const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);

    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [showFileCard, setShowFileCard] = useState(false);

    const [showLeftPanel, setShowLeftPanel] = useState(true);
    const [showRightPanel, setShowRightPanel] = useState(true);

    const [refreshAfterExit, setRefreshAfterExit] = useState(false);
    const [closeOnSend, setCloseOnSend] = useState(false);

    const [splitBodyData, setSplitBodyData] = useState({});

    const emptyGeoJson = {
        "type": "FeatureCollection",
        features: []
    }

    let collection = emptyGeoJson;
    let collectionToSplit = null;
    let expectFeatures = 0;


    React.useEffect(() => {
        setOwnerId(props.clientid);
        setFieldId(props.fieldid);
        console.log("PROPS");
        console.log(props);
        //init(props);
        localStorage.setItem("lockvehicles", "true");
        if (files.length==0) 
        {
            //getUserFiles(session, props.clientid, setFiles, "json");   
            getUserFiles(session, props.clientid, collectFiles, "json");   
            
        }

        //if (props.fieldid) getFieldFiles(session, props.fieldid, updateFiles,"json");   //// important    
        
    }, []);


    React.useEffect(() => {
        /* 
        console.log("FILES");
        console.log(files);
        let res = files.filter(f => f.category == "results");
        if (res.length>0) setResults(res);
        console.log("Results");
        console.log(res);
        */
    }, [files]);



    function collectFiles(files)
    {
        if (files.length>0)
            {
            setFiles(files);
            let res = files.filter(f => f.category == "results");
            if (res.length>0) setResults(res);
            }
    }    

    



    function init(props) {
        if (props.fieldid > 0) {
            setAction('update');

            let fieldarray = fields.filter(f => f.id == props.fieldid);
            if (fieldarray.length == 1) {
                let field = fieldarray[0];
                setOwnerId(field.owner);
                setName(field.name);
                setCrops(field.crops);
                setDescription(field.description);
                setArea(field.area);


                if (field.shape) {
                    //add a bit of delay for better rendering
                    //showGeoJson(JSON.parse(field.shape), false);
                }
            }
        }
    }




    function handleFileCardClose(refresh) {
        if ((refresh) && (fieldid)) getFieldFiles(session, props.fieldid, setFiles);
        setShowFileCard(false);
    }

  



    function resizeBoundingBox(bounds) {
        var point1 = turf.point([bounds[0], bounds[1]]);
        var point2 = turf.point([bounds[2], bounds[3]]);
        var bearing = turf.bearing(point1, point2);
        var distance = turf.distance(point1, point2);
        var p1 = turf.destination(point1, -0.2 * distance, bearing);
        var p2 = turf.destination(point2, 0.2 * distance, bearing);
        var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
        return box;
    }


    function applyFeatureCollection(collection) {
        dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: { features: collection } }));
    }

    function applyBoundingBox(bounds) {
        dispatchEvent(new CustomEvent('boundingBoxChangedPanel', { detail: { bounds: bounds } })); 
    }


    function applyMinMax(min, max, side) {
        //localStorage.setItem('featureCollection', JSON.stringify(collection));
        
        dispatchEvent(new CustomEvent("minMaxChangedPanel", { detail: {min : min, max: max, side: side }}));
    }



    function handlePanelSwitch()
    {
        if (panelSwitchState==1)
        {
            //był jeden panel - teraz będą 2 
            setMapStyle({ position: 'relative', width: '46vw', height: '86vh' });
            setPanelSwitchTooltip("Przełącz na widok 1 Panelu");
            setPanelSwitchState(2);
            

        }
        else
        {
            setPanelSwitchTooltip("Przełącz na widok 2 Paneli");
            setPanelSwitchState(1);
            setMapStyle({ position: 'relative', width: '93vw', height: '86vh' });
        }
    }


    function collectFeatures(feature) {
        console.log('collect');
        console.log(feature);
        if (!feature) return;
        collection.features.push(feature);
        console.log("expected " + expectFeatures + " got " + collection.features.length)
        if ((expectFeatures > 0) && (collection.features.length == expectFeatures))
            collectFinished();
    }

    function collectFinished() {
        console.log('finished');
        showGeoJson(collection, true);
        collection = emptyGeoJson;
    }


    function showGeoJson(feature, refresh) {
        if (!feature) return;

        let collection;
        try {
            if (feature.type == "FeatureCollection") {
                collection = feature;
            }
            else if (feature.type == "Feature") {
                collection = {
                    "type": "FeatureCollection",
                    features: [feature]
                }
            }
        } catch { console.log('unknown feature type'); }

        if (collection.features.length == 0) {
            console.log('No features to display');
            return;
        }

        console.log('Featrue Collection ready to display');
        console.log(collection);
        setFeaturesCount(collection.features.length);

        let area = turf.area(feature) / 10000.0;
        let bounds = turf.bbox(feature);
        let center = turf.center(feature);
        let resizedbounds = resizeBoundingBox(bounds);

        //grid(resizedbounds, collection);
        //gridtest(resizedbounds, collection);

        applyFeatureCollection(collection);
        applyBoundingBox(resizedbounds);

        setArea(area.toFixed(2));
        setBBox(JSON.stringify(bounds));
        setShape(JSON.stringify(feature));

        if (refresh) setShowPreview(true);
    }



    function cancelClose() {
        localStorage.setItem("lockvehicles", "false");
        console.log("close on send : " + closeOnSend);

        if (clearOnExit) {
            applyFeatureCollection(emptyGeoJson);
        }
        props.close(refreshAfterExit);
    }



    var shpwrite = require("shp-write-update");

    function download_default() {
        var options = {
            folder: 'granice',
            types: {
                point: 'points',
                polygon: 'granice',
                polyline: 'lines'
            },
            file: 'granice'

        }
        // a GeoJSON bridge for features
        let parsed = JSON.parse(shape);
        console.log('downloading shape');
        console.log(parsed);
        shpwrite.download(parsed, options);
    }


    function datefromTimestamp(timestamp)
    {
        var date = new Date(Number(timestamp));
        console.log(date);
        var day="0"+ date.getDate();
        var month="0"+ (date.getMonth()+1);
        var year=date.getFullYear();

        // Will display time in 10:30:23 format
        var formatted = year + '-' + month.substr(-2) + '-' + day.substr(-2);
        return formatted;
    }



    function Panel(props) {
        const [featureCollection, setFeatureCollection] = useState(JSON.parse(localStorage.getItem("featureCollection")) || emptyGeoJson);
        const [labParams, setLabParams] = useState([]);
        
        const [selectedParam, setSelectedParam] = useState(localStorage.getItem("parameter") || "value");
        const [min, setMin] = useState(1);
        const [max, setMax] = useState(5);
        const [side] = useState(props.side);
        const [onEnlarge] = useState(props.onEnlarge);
        const [boundingBox, setBoundingBox] = useState();
        const [analizy,setAnalizy] = useState(props.analizy || JSON.parse(localStorage.getItem("analizy")) || []);

        React.useEffect(() => {

            //init(props);
            featureCollection.features.forEach(element => {
                //element.properties.color = "#80ff80"; 
                //element.properties.value = 5; 
            })
            setFeatureCollection(featureCollection);
            setBoundingBox(getBoundingBox(featureCollection));    
            if (analizy.length==0) getAnalizy(session,collectAnalizy);

        }, []);


    function collectAnalizy(data)
        {
            console.log("collect ");
            console.log(data)                        
            localStorage.setItem("analizy",JSON.stringify(data));
            setAnalizy(data);
        }



    function getBoundingBox(features) {
        let bounds = turf.bbox(features);
        let resizedbounds = resizeBoundingBox(bounds);
        return resizedbounds;
    }

        function getColor(value) {
            let color = "#ffff80";
            if (selectedParam.startsWith('Ocena')) {
                switch (value) {
                    case 1: color = "#ff0000"; break;
                    case 2: color = "#ff8000"; break;
                    case 3: color = "#ffff00"; break;
                    case 4: color = "#80ff00"; break;
                    case 5: color = "#00ff00"; break;
                    case 6: color = "#00ff80"; break;
                    case 7: color = "#00ffff"; break;
                    case 8: color = "#0080ff"; break;
                    case 9: color = "#0000ff"; break;
                }

            }
            console.log(color);
            return '#000080';

        }









        function parseLabPrams(collection) {
            let allkeys = [];
            collection.features.forEach(element => {
                let keys = Object.keys(element.properties);
                keys.forEach(key => {
                    if (!allkeys.includes(key)) allkeys.push(key);
                })
            });
            if (allkeys.includes('gpsnr')) allkeys.splice(allkeys.indexOf('gpsnr'), 1);
            if (allkeys.includes('value')) allkeys.splice(allkeys.indexOf('value'), 1);
            console.log("--------- allkeys ------------");
            console.log(allkeys);
            setLabParams(allkeys);
            //if (allkeys.length > 0) handleParamChange(null);
        }


        const selectFile = (e) => {
            const fileid = e.currentTarget.getAttribute("data-fileid");
            let file = files.filter(f => f.id == fileid)[0];
            try {
                let collection = JSON.parse(file.jsondata);

                setFeatureCollection(collection);
                parseLabPrams(collection);

            } catch { };
        };

        function changeResults(rid) {
            console.log("changing results");
            let file = files.filter(f => f.id == rid)[0];
            try {
                let collection = JSON.parse(file.jsondata);

                setFeatureCollection(collection);
                parseLabPrams(collection);

            } catch { };
        };


        function getValue(value, _min, _max) {

            let _step = (_max - _min) / 4;
            let _v = _min;
            for (_v = _min; value <= _max; value += _step)
                if (_v > value) break;
            return _v;
        }


        function applyFeaturesColor(parameter,search, min, max) {

            if (search==true) {
                min = 1000; max = 0;
                featureCollection.features.forEach(element => {
                    let value = element.properties[parameter];
                    //element.properties.color = getColor(value); 
                    if (value < min) min = value;
                    if (value > max) max = value;
                })
                console.log('Min,Max Search completed');
            }
            console.log('min ' + min);
            console.log('max ' + max);

            featureCollection.features.forEach(element => {
                let value = element.properties[parameter];
                element.properties.value = getValue(value, min, max);
                //element.properties.polygonName = "" + value;
                //element.properties.label = "" + value;
                element.properties.polygonName = "";
                element.properties.label = "";
            })

            console.log(featureCollection);
            setFeatureCollection({ ...featureCollection });
            applyFeatureCollection(featureCollection);
            applyMinMax(min, max, side);
        }


        function changeParameter(newparam)
        {
            localStorage.setItem("parameter", newparam);
            setSelectedParam(newparam);
            
            //applySelectedParameter(newparam); //not needed
            
            if (selectedParam=="value") 
                {
                    console.log("selected param was " + selectedParam);
                    //applyFeatures(mapFeatures);
                }

            let _min, _max;
            let search = true;

            if (newparam.startsWith('Ocena')) {
                _min = 1; _max = 5; search = false;
            }
            else {
                search=true;
                if (newparam == "Mg") {
                    _min = 5;
                    _max = 100;
                    search = true;
                }
                if (newparam == "K2O") {
                    _min = 4;
                    _max = 25;
                }
                if (newparam == "P2O5") {
                    _min = 4;
                    _max = 35;
                }
                if (newparam.startsWith('ph')) {
                    _min = 3;
                    _max = 11;
                }
                if (newparam.startsWith('selected')) {
                    _min = 0;
                    _max = 1;
                    search = false;
                }
                
            }

            if (search == true) {
                _min = 1000; _max = 0;
                console.log(featureCollection);
                featureCollection.features.forEach(element => {    //was labFeatures
                    let value = element.properties[newparam];
                    //element.properties.color = getColor(value); 
                    if (value < _min) _min = value;
                    if (value > _max) _max = value;
                })
                console.log('Min,Max Search completed');
            }

            setMin(_min);
            setMax(_max);
            console.log("update colors")
            
            //updateFeaturesColor(newparam, search, _min, _max);
            applyMinMax(_min, _max, side); //a bit faster that update colors 
            
            //console.log(featureCollection);

        }



        function handleParamChange(e) {
            let newparam=labParams[0];
            if (e.currentTarget)
            newparam = e.currentTarget.getAttribute("data-param");

            setSelectedParam(newparam);
            changeParameter(newparam);
        }
        
        
        function handleParamChangeOld(e) {
            let newparam=labParams[0];
            if (e.currentTarget)
            newparam = e.currentTarget.getAttribute("data-param");

            setSelectedParam(newparam);
            let _min, _max;
            let search = true;

            if (newparam.startsWith('Ocena')) {
                _min = 1; _max = 5; search = false;
            }
            else {
                search=true;
                if (newparam == "Mg") {
                    _min = 5;
                    _max = 100;
                    
                }
                if (newparam == "K2O") {
                    _min = 4;
                    _max = 25;
                }
                if (newparam == "P2O5") {
                    _min = 4;
                    _max = 35;
                }
                if (newparam.startsWith('ph')) {
                    _min = 3;
                    _max = 11;
                }
            }
            setMin(_min);
            setMax(_max);
            console.log("min " + _min + " max " + _max);
            applyFeaturesColor(newparam,search, _min, _max);
            
            //applyMinMax(_min,_max);
            console.log(featureCollection);
        }


        return (
            <div className='mx-auto border rounded-lg bg-gray-50'>

                <div className='mx-auto w-full rounded-lg bg-gray-500 h-0 my-0 selected:text-black'>
                    {labParams.length > 0 && <Tabs value={selectedParam}>
                        <TabsHeader className='text-xs h-12 bg--gray-500 p-2 shadow-none !text-white'>
                            {
                                labParams.map(param => {
                                    let friendlyname = param;
                                    var analiza=analizy.find(a => a.sysname===param);
                                    if (analiza) friendlyname=analiza.shortname;
                                    /*
                                    switch (param) {
                                        case "Ocena_ph": friendlyname = "Ocena PH"; break;
                                        case "Ocena_p2o5": friendlyname = "Ocena Fosforu"; break;
                                        case "Ocena_k2o": friendlyname = "Ocena Potasu"; break;
                                        case "Ocena_mg": friendlyname = "Ocena Magnezu"; break;
                                        case "ph_gleby": friendlyname = "Wartość PH"; break;
                                        case "P2O5": friendlyname = "Fosfor"; break;
                                        case "K2O": friendlyname = "Potas"; break;
                                        case "MG": friendlyname = "Magnez"; break;
                                    }
                                    */    
                                    return (
                                        <Tab key={param} value={param} data-param={param} className={`text-xs ${param === selectedParam ? "bg-white" : "bg-black/50 text-white"}`} onClick={handleParamChange}>
                                            {friendlyname}
                                        </Tab>
                                    )
                                })}
                        </TabsHeader>
                    </Tabs>
                    }
                </div>
                 <div id="map_border" className='rounded-lg border border-green-200 p-1'>
                    <MapboxPanel features={featureCollection} selected={selectedParam} min={min} max={max} boundingBox={boundingBox} showLegend={true} side={side} style={mapStyle} results={results} showNumbers={true} onChangeResults={changeResults}/>
                 </div>      
            </div>
        )
    }











    return (

        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[20] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-auto w-[95vw] mx-auto rounded-lg shadow-lg h-[95vh] " shadow={true}>

                <div className="flex flex-row items-center justify-between gap-2 w-auto mt-2">
                    <div color="gray" className="mt-0 mx-auto flex flex-row gap-4">
                        <Typography className="h-10 mt-2 text-md ">Wyniki badań</Typography>
                        <Tooltip content={panelSwitchTooltip}>
                        <Button variant='filled' className='w-14 h-10 items-center justify-center flex flex-row bg-gray-500/10 border border-green-200 hover:bg-gray-500/25 shadow-none hover:shadow-none' onClick={handlePanelSwitch}>
                        <div className='flex flex-row w-10 ml-1'>
                        <DocumentIcon className='w-5 h-5' />
                        {panelSwitchState==1 && <DocumentIcon className='w-5 h-5' />}
                        </div>
                        </Button>
                        </Tooltip>
                    </div>


                    <IconButton variant='text' className='-top-1 right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>
                </div>
                <div className="w-auto flex flex-row items-center gap-2 m-2">
                    <Panel side="left" style={mapStyle}/>
                    {panelSwitchState==2 && <Panel side="right" style={mapStyle}/>}
                </div>
            </Card>
            {showFileCard && <FileUploadCard close={handleFileCardClose} fieldid={fieldid} />}
        </div>

    );


}

